/* eslint-disable react/no-array-index-key */
import {
  Box,
  Typography,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import ExportCsvButton from "../../shared/export/export-csv-button";
import type { CsvColumn } from "../../shared/export/csv-export";

const exportColumns: CsvColumn<string>[] = [
  { header: "Expression", value: (regex) => regex },
];

interface RegexListProps {
  expressions: string[];
  onEdit: (index: number) => void;
  onDelete: (index: number) => void;
}

const RegexList = ({ expressions, onEdit, onDelete }: RegexListProps) => {
  if (expressions.length === 0) {
    return (
      <Box
        sx={{
          p: 4,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Typography variant="body2" color="text.secondary" textAlign="center">
          No expressions configured
        </Typography>
      </Box>
    );
  }

  return (
    <TableContainer
      sx={{
        maxHeight: 300,
        overflowY: "auto",
        "&::-webkit-scrollbar": {
          display: "none",
        },
        scrollbarWidth: "none",
        msOverflowStyle: "none",
      }}
    >
      <Table size="small" stickyHeader>
        <TableHead>
          <TableRow
            sx={{
              "& .MuiTableCell-root": {
                fontWeight: 600,
                color: "primary.main",
                bgcolor: "grey.50",
              },
            }}
          >
            <TableCell>Expression</TableCell>
            <TableCell align="right">
              <ExportCsvButton
                rows={expressions}
                columns={exportColumns}
                fileName="regular-expressions"
              />
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {expressions.map((regex, index) => (
            <TableRow
              key={`regex-${index}`}
              sx={{
                "&:hover": {
                  bgcolor: "action.hover",
                },
                "&:last-child td": {
                  borderBottom: 0,
                },
              }}
            >
              <TableCell sx={{ py: 1.5 }}>{regex}</TableCell>
              <TableCell align="right" sx={{ py: 1, whiteSpace: "nowrap" }}>
                <IconButton
                  size="small"
                  onClick={() => onEdit(index)}
                  aria-label="Edit expression"
                  sx={{
                    color: "text.secondary",
                    mr: 0.5,
                    "&:hover": {
                      color: "primary.main",
                      bgcolor: "primary.lighter",
                      transform: "scale(1.1)",
                    },
                    transition: "all 0.2s ease-in-out",
                  }}
                >
                  <EditIcon fontSize="small" />
                </IconButton>
                <IconButton
                  size="small"
                  onClick={() => onDelete(index)}
                  aria-label="Delete expression"
                  sx={{
                    color: "text.secondary",
                    "&:hover": {
                      color: "error.main",
                      bgcolor: "error.lighter",
                      transform: "scale(1.1)",
                    },
                    transition: "all 0.2s ease-in-out",
                  }}
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default RegexList;
